import React from 'react';

import moment from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Flight } from 'models/flight';
import { getFlightClass } from 'utils/generic';

import { formatDuration, getTime } from '../utils';
import {
  AirlineWrapper,
  FlightDetailCardRoot,
  Header,
  AirlineName,
  AirlineLogo,
  FlightNumber,
  Body,
  DepartureWrapper,
  RouteTypeLabel,
  Date,
  Time,
  CityName,
  Airport,
  AirportName,
  DepartureRouteTypeWrapper,
  DepartureAirportWrapper,
  ArrivalWrapper,
  ArrivalRouteTypeWrapper,
  ArrivalAirportWrapper,
  FlightLineContainer,
  FlightLineTopText,
  FlightLine,
  FlightLineBottomText,
  FlightLineBottomTextStrong,
  OperatorName,
} from './styles';

interface Props {
  flight: Flight;
}

const FlightDetailCard = ({
  flight: {
    airlineCode,
    airlineName,
    flightTimeInternalInSeconds,
    number,
    departureDate,
    departureAirport,
    departureAirportName,
    departureCityName,
    arrivalDate,
    arrivalAirport,
    arrivalAirportName,
    arrivalCityName,
    equipment,
    opAirLineCode,
    opAirLineName,
    cabin,
    airlineConfirmationCode,
  },
}: Props) => {
  const { t } = useStoreTranslation();

  return (
    <FlightDetailCardRoot>
      <Header>
        <AirlineWrapper>
          <AirlineLogo airline={airlineCode} />
          <AirlineName>{airlineName} ({airlineConfirmationCode})</AirlineName>
        </AirlineWrapper>
        <FlightNumber>{t('flightsCard.detailCard.flight', { flightNumber: `${opAirLineCode}${number}` })}</FlightNumber>
      </Header>
      {opAirLineCode && opAirLineName && opAirLineCode !== airlineCode && <OperatorName>{t('flightsCard.detailCard.operatorAirline', { airlineName: `${opAirLineName ?? opAirLineCode}` })}</OperatorName>}
      <Body>
        <DepartureWrapper>
          <DepartureRouteTypeWrapper>
            <RouteTypeLabel>{t('flightsCard.detailCard.departure')}</RouteTypeLabel>
            <Date>{moment(departureDate).utc().format('ddd, D MMM')}</Date>
            <Time>{getTime(departureDate)}</Time>
          </DepartureRouteTypeWrapper>
          <DepartureAirportWrapper>
            <Airport>{departureAirport}</Airport>
            <CityName>{departureCityName}</CityName>
            <AirportName>{departureAirportName}</AirportName>
          </DepartureAirportWrapper>
        </DepartureWrapper>
        <FlightLineContainer>
          <FlightLineTopText>{formatDuration(flightTimeInternalInSeconds, 'seconds')}</FlightLineTopText>
          <FlightLine />
          <FlightLineBottomTextStrong>{t(getFlightClass(cabin))}</FlightLineBottomTextStrong>
          <FlightLineBottomText>{equipment}</FlightLineBottomText>
        </FlightLineContainer>
        <ArrivalWrapper>
          <ArrivalRouteTypeWrapper>
            <RouteTypeLabel>{t('flightsCard.detailCard.arrival')}</RouteTypeLabel>
            <Date>{moment(arrivalDate).utc().format('ddd, D MMM')}</Date>
            <Time>{getTime(arrivalDate)}</Time>
          </ArrivalRouteTypeWrapper>
          <ArrivalAirportWrapper>
            <Airport>{arrivalAirport}</Airport>
            <CityName>{arrivalCityName}</CityName>
            <AirportName>{arrivalAirportName}</AirportName>
          </ArrivalAirportWrapper>
        </ArrivalWrapper>
      </Body>
    </FlightDetailCardRoot>
  );
};

export default FlightDetailCard;
